// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2gOl4","left":"styles_left__1F35e"};